import {dialogApi} from '../../../../../api/dialogApi'
import styles from './KeyMetricsCard.module.scss'
import {cx} from '../../../../../utils'
import {
  WuCard,
  WuCardHeader,
  WuHeading,
  WuIcon,
} from '@npm-questionpro/wick-ui-lib'
import {IDialogDetails} from '../../../../../types'
import {useParams} from 'react-router'
import {useWt} from '@npm-questionpro/wick-ui-lib'
import {DIALOG} from '../../../../../Translation/English/dialog'

export const KeyMetricsCard: React.FC = () => {
  const wt = useWt()
  const {dialogId} = useParams<{dialogId: string}>()
  const {data: dialogDetails} = dialogApi.useDialogDetails(dialogId ?? '') as {
    data: IDialogDetails
  }

  if (!dialogDetails) return null

  return (
    <>
      <WuCard rounded>
        <WuCardHeader className={styles.cardHeading}>
          <WuHeading size="sm">{wt(DIALOG.keyMetrics)}</WuHeading>
        </WuCardHeader>
        <div className={styles.keyMetricsContainer}>
          <div className={styles.keyMetricsItem}>
            <div className={styles.keyMetricsValue}>
              {dialogDetails.totalParticipantsCount}
            </div>
            <div className={styles.keyMetricsLabel}>
              <WuIcon icon="wm-group" className={styles.keyMetricsLabelIcon} />
              <div className={styles.keyMetricsLabelText}>
                {wt(DIALOG.participants)}
              </div>
            </div>
          </div>
          <div className={styles.keyMetricsItem}>
            <div className={styles.keyMetricsValue}>
              {dialogDetails.totalResponsesCount}
            </div>
            <div className={styles.keyMetricsLabel}>
              <WuIcon icon="wm-chat" className={styles.keyMetricsLabelIcon} />
              <div className={styles.keyMetricsLabelText}>
                {wt(DIALOG.responses)}
              </div>
            </div>
          </div>
          <div className={styles.keyMetricsItem}>
            <div className={styles.keyMetricsValue}>
              {dialogDetails.totalRepliesCount}
            </div>
            <div className={styles.keyMetricsLabel}>
              <WuIcon
                icon="wm-arrow-top-left"
                className={styles.keyMetricsLabelIcon}
              />
              <div className={styles.keyMetricsLabelText}>
                {wt(DIALOG.comments)}
              </div>
            </div>
          </div>
          <div className={styles.keyMetricsItem}>
            <div className={styles.keyMetricsValue}>
              {dialogDetails.likesCount}
            </div>
            <div className={styles.keyMetricsLabel}>
              <WuIcon
                icon="wm-thumb-up"
                className={cx(
                  styles.keyMetricsLabelIcon,
                  styles.keyMetricsLabelGreen,
                )}
              />
              <div className={styles.keyMetricsLabelText}>
                {wt(DIALOG.likes)}
              </div>
            </div>
          </div>
          <div className={styles.keyMetricsItem}>
            <div className={styles.keyMetricsValue}>
              {dialogDetails.dislikesCount}
            </div>
            <div className={styles.keyMetricsLabel}>
              <WuIcon
                icon="wm-thumb-down"
                className={cx(
                  styles.keyMetricsLabelIcon,
                  styles.keyMetricsLabelRed,
                )}
              />
              <div className={styles.keyMetricsLabelText}>
                {wt(DIALOG.dislikes)}
              </div>
            </div>
          </div>
        </div>
      </WuCard>
    </>
  )
}
